import axios from 'axios';

//FOR PRODUCTION:
const url = 'https://lexdex.ch/wp-json/dsg/v1/';

//const url = "http://localhost/wp-json/dsg/v1/";

/* global lexdex_wp */
var nonce = (() => {
  if (lexdex_wp) {
    return lexdex_wp.nonce;
  } else if (window.lexdex_wp) {
    return window.lexdex_wp.nonce;
  } else {
    console.log('lexdex_wp not defined');
    return '';
  }
})();

const config = {
  headers: {
    'X-WP-Nonce': nonce
  }
};

export const getUserData = () => {
  console.log('Fetching user data...');
  return fetchWithRetry(() => axios.get(url + 'userData/', config))
    .then(data => {
      console.log('Received user data:', data);
      return data;
    })
    .catch(error => {
      console.error('Error fetching user data:', error);
      throw error;
    });
};

export const getQuestions = () => {
  return fetchWithRetry(() => axios.get(url + 'questions/', config));
};

export const submitAnswers = (answers) => {
  return fetchWithRetry(() => axios.post(url + 'submit/', answers, config));
};

export const getPDF = () => {
  return fetchWithRetry(() => axios.get(url + 'pdf/', { ...config, responseType: 'blob', responseEncoding: 'binary' }));
};

export const getHTML = () => {
  return fetchWithRetry(() => axios.get(url + 'html/', config));
};

export const getMD = () => {
  return fetchWithRetry(() => axios.get(url + 'md/', config));
};

export const getStoredAnswers = () => {
  console.log('Fetching stored answers...');
  return fetchWithRetry(() => axios.get(url + 'answers/', config))
    .then(data => {
      console.log('Received stored answers:', data);
      return data;
    })
    .catch(error => {
      console.error('Error fetching stored answers:', error);
      throw error;
    });
};

export const saveAnswers = (answers) => {
  console.log('Saving answers to DB:', answers);
  return fetchWithRetry(() => axios.post(url + 'answers/', answers, config))
    .then(response => {
      console.log('Save answers response:', response);
      return response;
    })
    .catch(error => {
      console.error('Error saving answers:', error);
      throw error;
    });
};

const retryDelay = (attempt, maxJitter) => {
  const baseDelay = Math.pow(2, attempt) * 1000;  // Exponential backoff
  const jitter = Math.floor(Math.random() * maxJitter);  // Add jitter
  return baseDelay + jitter;
};

const fetchWithRetry = async (axiosCall, retries = 3, jitter = 500) => {
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      const response = await axiosCall();
      console.log('API Response:', response);
      if (response.status >= 200 && response.status < 300) {
        return response.data;
      } else {
        throw new Error(`Error fetching data, status ${response.status}`);
      }
    } catch (error) {
      console.error(`API Error (attempt ${attempt + 1}/${retries + 1}):`, error);
      
      if (axios.isAxiosError(error) && !error.response) {
        console.error('Network error:', error);  // Network errors
        break;
      }

      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        console.error(`Aborting retries. Received status code ${error.response.status}`);  // If 401 or 403 is received, abort retries
        return error.response.data;
      }

      if (attempt === retries) {
        console.error('Retry limit reached:', error);  // Feedback on ultimate failure
        throw error;
      }
      await new Promise(resolve => setTimeout(resolve, retryDelay(attempt, jitter)));
    }
  }
};
